import { Component, OnInit } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { MatDialogRef } from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import { DataStorageService } from '../data-storage.service';

@Component({
  selector: 'app-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.css']
})
export class DialogConfirmComponent implements OnInit {

  public title: string;
  public message: string;
  public value: string;

  constructor(public dialogRef: MatDialogRef<DialogConfirmComponent>,
    private translate: TranslateService,
    private dataStorage: DataStorageService) {
      translate.setDefaultLang('en');
      translate.use(dataStorage.getLanguage());
    
  }

  ngOnInit() {
    let tempTitle = this.title;
    this.title = "";
    let tempMessage = this.message;
    this.message = "";
    this.translate.get(tempTitle).subscribe(data => {
      this.title = data;
    });
    this.translate.get(tempMessage, {object: this.value}).subscribe(data => {
      this.message = data;
      if (tempMessage === data) {
        this.message = data + this.value + "?";
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/dialog-confirm/dialog-confirm.component.ts